const pagesNetworksEn = {
  add: {
    progressbar: {
      filled: 'Filled',
      modeSetting: 'Input Mode Settings',
      mustItem: 'Required Items',
      mustItemOnly: 'Required Items Only',
      mustOnlyMode: 'Must Only Mode',
      optionalFields: 'Optional Fields',
      requiredFields: 'Required Fields',
      title: 'Progress',
      toggleMustOnly: 'Toggle Must Only Mode',
      total: 'Total',
      totalFields: 'Total Fields'
    },
    step1: {
      connectionType: {
        label: 'Wired/Wireless',
        placeholder: 'Select wired/wireless'
      },
      destinationType: {
        label: 'Destination Type',
        placeholder: 'Select destination type'
      },
      deviceId: {
        label: 'Destination Device',
        placeholder: 'Select destination device'
      },
      networkCategory: {
        label: 'Network Category',
        placeholder: 'Select network category'
      },
      networkName: {
        label: 'Network Name',
        placeholder: 'Enter network name'
      },
      networkType: {
        label: 'Network Type',
        placeholder: 'Select network type'
      },
      next: 'Next',
      placeId: {
        label: 'Destination Place',
        placeholder: 'Select destination place'
      },
      purpose: {
        label: 'Usage Purpose',
        placeholder: 'Enter network usage purpose'
      },
      submitting: 'Submitting...',
      title: 'Network Basic Information'
    },
    step2: {
      accessLevel: {
        label: 'Permission Type',
        placeholder: 'Select permission type'
      },
      accessPeriodFrom: {
        label: 'Access Valid Period (From)',
        placeholder: 'Enter access start date/time'
      },
      accessPeriodTo: {
        label: 'Access Valid Period (To)',
        placeholder: 'Enter access end date/time'
      },
      accessStatus: {
        label: 'Access Status',
        placeholder: 'Select access status'
      },
      back: 'Back',
      subjectType: {
        label: 'Access Subject Type',
        placeholder: 'Select access subject type'
      },
      submit: 'Submit',
      submitting: 'Submitting...',
      title: 'Access Control Management'
    },
    stepper: {
      accessControl: 'Access Control Management',
      networkInformation: 'Network Information'
    },
    title: 'Add Network',
    toast: {
      error: {
        title: 'Error'
      },
      success: {
        description: 'Network has been created successfully',
        title: 'Success'
      },
      validationError: {
        description: 'Please check required fields',
        title: 'Input Error'
      }
    }
  },
  detail: {
    destinationTypes: {
      device: 'Destination Device',
      place: 'Destination Place'
    },
    fields: {
      // Network Information fields
      adminContact: 'Admin Manager',
      connectionType: 'Wired/Wireless',
      destinationDevice: 'Destination Device',
      destinationPlace: 'Destination Place',
      destinationType: 'Destination Type',
      networkCategory: 'Network Category',
      networkName: 'Network Name',
      networkType: 'Network Type',
      purpose: 'Usage Purpose',
      // Access Control fields
      accessEndDate: 'Access Valid Period (End)',
      accessLevel: 'Permission Type',
      accessStartDate: 'Access Valid Period (Start)',
      accessStatus: 'Access Status',
      subjectType: 'Access Subject Type',
      // Connection Information fields
      connectedWifi: 'Connected Wi-Fi Name',
      iccid: 'ICCID Number',
      ipAddress: 'IP Address',
      mobileCarrier: 'Carrier Name',
      networkStatus: 'Communication Status',
      simStatus: 'SIM Status',
      // Configuration fields
      connectionProfile: 'Connection SSID/VPN Name',
      dnsServer: 'DNS Setting',
      hostname: 'Hostname',
      proxySetting: 'Proxy Setting'
    },
    sections: {
      networkAccessControl: 'Access Control Management',
      networkConfiguration: 'Network Configuration',
      networkConnectionInformation: 'Network Connection Information',
      networkInformation: 'Network Basic Information'
    },
    values: {
      accessLevel: {
        FULL_ACCESS: 'Full Access',
        LIMITED: 'Limited',
        NO_ACCESS: 'No Access',
        READ_ONLY: 'Read Only'
      },
      accessStatus: {
        ACTIVE: 'Active',
        EXPIRED: 'Expired',
        INACTIVE: 'Inactive',
        SUSPENDED: 'Suspended'
      },
      networkStatus: {
        CONNECTED: 'Connected',
        DISCONNECTED: 'Disconnected',
        OUT_OF_SERVICE: 'Out of Service',
        ROAMING: 'Roaming'
      },
      simStatus: {
        ACTIVE: 'Active',
        INACTIVE: 'Inactive',
        SUSPENDED: 'Suspended',
        UNKNOWN: 'Unknown'
      },
      subjectType: {
        DEVICE: 'Device',
        GROUP: 'Group',
        USER: 'User'
      }
    }
  },
  filters: {
    connectionType: 'Wired/Wireless',
    connectionTypePlaceholder: 'Search by wired/wireless',
    connectionTypeValues: {
      BOTH: 'Both',
      WIRED: 'Wired',
      WIRELESS: 'Wireless'
    },
    destination: 'Destination',
    destinationTypes: {
      DEVICE: 'Destination Device',
      PLACE: 'Destination Place'
    },
    networkCategoryValues: {
      COMPANY_ASSET: 'Company Asset Network',
      CUSTOMER_ENVIRONMENT: 'Customer Environment Network',
      PERSONAL_USE: 'Personal Use Network',
      SHARED_INTERNAL: 'Shared Internal Network'
    },
    networkType: 'Network Type',
    networkTypePlaceholder: 'Search by network type',
    networkTypeValues: {
      CLOUD: 'Cloud',
      DEDICATED_LINE: 'Dedicated Line',
      EXTERNAL: 'External',
      INTERNAL: 'Internal',
      VPN: 'VPN'
    },
    purpose: 'Usage Purpose'
  },
  list: {
    addNetwork: 'Add Network',
    filterPlaceholder: 'Filter by network name',
    pageTitle: 'Networks',
    tabs: {
      all: 'All',
      companyAsset: 'Company Asset',
      customerEnvironment: 'Customer Environment',
      personalUse: 'Personal Use',
      sharedInternal: 'Shared Internal'
    }
  }
};
export default pagesNetworksEn;